import { useState } from 'react';
import { apiJson, fetchFaqBlockFile } from '../api/client.js';

/**
 * @param {{ blockId: number, label?: string, field: 'username' | 'password', masked?: string | null, revealPath?: string }} props
 */
export function SecureCredentialField({ blockId, label, field, masked, revealPath }) {
  const [revealed, setRevealed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const path = revealPath ?? `/api/my/faq/blocks/${blockId}/reveal-credential`;

  const reveal = async () => {
    if (revealed !== null) {
      setRevealed(null);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const data = await apiJson(path, { method: 'POST' });
      setRevealed(data[field] ?? '');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const copy = async () => {
    let value = revealed;
    if (value === null) {
      try {
        const data = await apiJson(path, { method: 'POST' });
        value = data[field] ?? '';
        setRevealed(value);
      } catch (e) {
        setError(e.message);
        return;
      }
    }
    if (value) {
      await navigator.clipboard.writeText(value);
    }
  };

  if (!masked) {
    return null;
  }

  const display = revealed !== null ? revealed : masked;

  return (
    <div className="faq-credential-row">
      <span className="faq-credential-label">{label || field}</span>
      <code className="faq-credential-value">{display}</code>
      <div className="row-actions">
        <button type="button" className="btn-secondary btn-sm" disabled={loading} onClick={() => void reveal()}>
          {loading ? '…' : revealed !== null ? 'Hide' : 'Show'}
        </button>
        <button type="button" className="btn-secondary btn-sm" onClick={() => void copy()}>
          Copy
        </button>
      </div>
      {error ? <span className="err small">{error}</span> : null}
    </div>
  );
}

/**
 * Authenticated file download (opens in new tab with bearer token via fetch blob).
 */
export async function downloadFaqFile(blockId, fileName = 'download', opts = {}) {
  const blob = await fetchFaqBlockFile(blockId, opts);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}
